import { render, staticRenderFns } from "./SolutionEmpty.vue?vue&type=template&id=62081684&scoped=true&lang=pug&"
import script from "./SolutionEmpty.vue?vue&type=script&lang=js&"
export * from "./SolutionEmpty.vue?vue&type=script&lang=js&"
import style0 from "./SolutionEmpty.vue?vue&type=style&index=0&id=62081684&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62081684",
  null
  
)

export default component.exports